import { Component, EventEmitter, Output } from '@angular/core';

import { UntypedFormBuilder, Validators } from '@angular/forms';

import { Producto } from 'src/app/interfaces/interfaces';


@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent {
  @Output() newProductEvent = new EventEmitter<Object>();

  srcResult: String = '';

  firstFormGroup = this._formBuilder.group({
    nombre: ['', Validators.required],
    codigo: [''],
    descripcion: [''],
    precio: [''],
    stock: [''],
  });

  secondFormGroup = this._formBuilder.group({
    imagen: ['', Validators.required],
  });




  isLinear = false;
  imageBase64: string = '';
  alergenos: string = '';

  constructor(private _formBuilder: UntypedFormBuilder) {}

  onFileSelected() {
    const inputNode: any = document.querySelector('#file');
  
    if (typeof (FileReader) !== 'undefined') {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.srcResult = e.target.result;
      };
  
      reader.readAsArrayBuffer(inputNode.files[0]);
    }
  }

  addProduct(){
    // nombre
    // codigo
    // descripcion
    // precio
    // stock

    let newProduct = {
      nombre : this.firstFormGroup.controls['nombre'].value,
      codigo : this.firstFormGroup.controls['codigo'].value,
      descripcion : this.firstFormGroup.controls['descripcion'].value,
      precio : this.firstFormGroup.controls['precio'].value,
      stock : this.firstFormGroup.controls['stock'].value,
      imagen : this.imageBase64
    }

    if(this.alergenos){
      newProduct = this.generateAlergenoList(newProduct, this.alergenos);
    }

    this.newProductEvent.emit(newProduct);
  }

  receiveImage($event: string){
    this.imageBase64 = $event;
  }
  receiveAlergenos($event: any){
    this.alergenos = $event;
  }

  generateAlergenoList = (product: any, arrayAlergenos: any) => {
    if(arrayAlergenos){
      arrayAlergenos.forEach((element: any) => {
        if(element.checked){
          product[element.cod] = 1;
        }
      });
    }
    return product;
  }

}
